import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexDirection, mb, mt, p, pl, w100} from "@pg-design/helpers-css-strings";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveOpenLink} from "../../../../hooks/use_responsive_open_link";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {clearOfferName} from "../../../utils/clear_offer_name";
import {AwardedPlaceIndicator} from "./AwardedPlaceIndicator";

interface IProps {
    className?: string;
    offer: Pick<IOfferDetail, "name" | "main_image" | "address" | "id" | "slug" | "vendor">;
    onClick?: () => void;
}

export const AwardedOffersBox = ({className, offer, onClick}: IProps) => {
    const offerUrl = useOfferLink({
        ...offer,
        groups: null
    });
    const openResponsiveLink = useResponsiveOpenLink(offerUrl);

    return (
        <div css={boxHolder} className={className} onClick={onClick}>
            <a href={offerUrl} target="_blank" css={header}>
                <div css={mobileHeadingHolder}>
                    <div css={placeHolderMobile}>
                        <AwardedPlaceIndicator showOnMobile />
                    </div>

                    <img css={offerImage} alt={offer.name} src={offer.main_image?.m_img_440x248} />
                </div>
            </a>

            <div css={boxDetailHolder} onClick={openResponsiveLink}>
                <div css={boxTextStyle}>
                    <Text as="p" mb={2} variant="headline_4">
                        {clearOfferName(offer.name)}
                    </Text>
                    <Text as="p" variant="body_copy_1">
                        {offer.address}
                    </Text>

                    <Button variant="none_secondary" iconRight={ChevronRightIcon} css={[mt(2), pl()]}>
                        Zobacz inwestycję
                    </Button>
                </div>

                <AwardedPlaceIndicator showOnMobile={false} />
            </div>
        </div>
    );
};

const boxHolder = css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 33.6rem;
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(2)};
    ${mb(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: row;
        max-width: unset;
        ${w100};
        ${mb(3)};
    }
`;

const mobileHeadingHolder = css`
    ${flex()};
    ${flexDirection("column")};
`;

const boxDetailHolder = css`
    ${flex("normal", "space-between")};
    ${w100};
    cursor: pointer;
    ${p(2, 2, 4)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(4, 4, 1)};
    }
`;

const boxTextStyle = css`
    ${flex("start", "center")};
    ${flexDirection("column")};
`;

const placeHolderMobile = css`
    background-color: ${getThemeVariable("colors.primary")};
    ${flexAbsoluteCenter};
    height: 4.8rem;
    max-height: 4.8rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: none;
    }
`;

const header = css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        color: ${getThemeVariable("colors.secondary")};
    }
`;

const offerImage = css`
    width: 100%;
    height: 25.6rem;
    min-height: 25.6rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        width: 28rem;
        height: 18.4rem;
        min-height: 18.4rem;
        border-radius: unset;
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexDirection, mb, mt, p, pl, w100} from "@pg-design/helpers-css-strings";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveOpenLink} from "../../../../hooks/use_responsive_open_link";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {clearOfferName} from "../../../utils/clear_offer_name";
import {AwardedPlaceIndicator} from "./AwardedPlaceIndicator";

interface IProps {
    className?: string;
    offer: Pick<IOfferDetail, "name" | "main_image" | "address" | "id" | "slug" | "vendor">;
    onClick?: () => void;
}

export const AwardedOffersBox = ({className, offer, onClick}: IProps) => {
    const offerUrl = useOfferLink({
        ...offer,
        groups: null
    });
    const openResponsiveLink = useResponsiveOpenLink(offerUrl);

    return (
        <div css={boxHolder} className={className} onClick={onClick}>
            <a href={offerUrl} target="_blank" css={header}>
                <div css={mobileHeadingHolder}>
                    <div css={placeHolderMobile}>
                        <AwardedPlaceIndicator showOnMobile />
                    </div>

                    <img css={offerImage} alt={offer.name} src={offer.main_image?.m_img_440x248} />
                </div>
            </a>

            <div css={boxDetailHolder} onClick={openResponsiveLink}>
                <div css={boxTextStyle}>
                    <Text as="p" mb={2} variant="headline_4">
                        {clearOfferName(offer.name)}
                    </Text>
                    <Text as="p" variant="body_copy_1">
                        {offer.address}
                    </Text>

                    <Button variant="none_secondary" iconRight={ChevronRightIcon} css={[mt(2), pl()]}>
                        Zobacz inwestycję
                    </Button>
                </div>

                <AwardedPlaceIndicator showOnMobile={false} />
            </div>
        </div>
    );
};

const boxHolder = css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 33.6rem;
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(2)};
    ${mb(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: row;
        max-width: unset;
        ${w100};
        ${mb(3)};
    }
`;

const mobileHeadingHolder = css`
    ${flex()};
    ${flexDirection("column")};
`;

const boxDetailHolder = css`
    ${flex("normal", "space-between")};
    ${w100};
    cursor: pointer;
    ${p(2, 2, 4)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(4, 4, 1)};
    }
`;

const boxTextStyle = css`
    ${flex("start", "center")};
    ${flexDirection("column")};
`;

const placeHolderMobile = css`
    background-color: ${getThemeVariable("colors.primary")};
    ${flexAbsoluteCenter};
    height: 4.8rem;
    max-height: 4.8rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: none;
    }
`;

const header = css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        color: ${getThemeVariable("colors.secondary")};
    }
`;

const offerImage = css`
    width: 100%;
    height: 25.6rem;
    min-height: 25.6rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        width: 28rem;
        height: 18.4rem;
        min-height: 18.4rem;
        border-radius: unset;
    }
`;
